import _asyncToGenerator from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js";
var cache = {};
export function cachedRequest(_x, _x2) {
  return _cachedRequest.apply(this, arguments);
}
function _cachedRequest() {
  _cachedRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, func) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (cache[key]) {
            _context.next = 4;
            break;
          }
          _context.next = 3;
          return func();
        case 3:
          cache[key] = _context.sent;
        case 4:
          return _context.abrupt("return", cache[key]);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _cachedRequest.apply(this, arguments);
}